<div class="header-wrp">
  <div class="header-wrp__preferences">
    <button type="button"
            class="btn btn-default"
            disabled
            (click)="openPreference()"
            style="display:none;">
      <span class="fa fa-cog"
            aria-hidden="true">
      </span>
    </button>
  </div>
  <div class="header-wrp__logo">
    <div>
      <img src="assets/images/logo.png">
    </div>
  </div>
  <div class="header-wrp__login">
    <label>
      {{userProfile != null ? userProfile.name : ''}}
    </label>
    <button type="button"
            class="btn btn-default img-circle"
            (click)="login()">
        <span class="fa fa-user"
              aria-hidden="true">
        </span>
    </button>
  </div>
</div>
<app-preference></app-preference>
<app-user-profile [title]='"Some standard title"'
                  [enableModal]="enableModal"
                  [showClose]='true'
                  [userProfile]="userProfile"
                  (closeEvent)="close()"
                  (showModal)="onEnableModal($event)"
                  #editModal>{{ bindModal(editModal) }}
</app-user-profile>
